export const NOTIFICATION_TYPES = {
  ERROR: "error",
  SUCCESS: "success",
  INFO: "info",
}



// WEBPACK FOOTER //
// ./src/store/notification/notification.constants.js